// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar-icon-selected {
  color: white;
  text-shadow: 0px 0px 2px #FFFFFF;
}
.toolbar-icon-not-selected {
  color: white;
  opacity: 0.5;
  text-shadow: unset;
}
.tippy-tooltip.yodiwo-theme {
  background-color: #505355;
  font-size: 0.8125rem;
  font-weight: 600;
}
.tippy-tooltip.yodiwo-theme[data-placement^=top] .tippy-arrow {
  border-width: 8px 8px 0;
  border-top-color: #505355;
}
.tippy-tooltip.yodiwo-theme[data-placement^=bottom] .tippy-arrow {
  border-width: 0 8px 8px;
  border-bottom-color: #505355;
}
.tippy-tooltip.yodiwo-theme[data-placement^=left] .tippy-arrow {
  border-width: 8px 0 8px 8px;
  border-left-color: #505355;
}
.tippy-tooltip.yodiwo-theme[data-placement^=right] .tippy-arrow {
  border-width: 8px 8px 8px 0;
  border-right-color: #505355;
}
.tippy-tooltip.yodiwo-theme .tippy-content {
  padding: 0.25rem 0.4375rem;
}
.tippy-tooltip.yodiwo-theme .tippy-backdrop {
  background-color: #505355;
}
.tippy-tooltip.yodiwo-theme .tippy-svg-arrow {
  fill: #505355;
}
.toolbar-icon-button-bubble {
  position: absolute;
  z-index: 1;
  transform: translate(50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  text-align: center;
  height: 14px;
  width: 16px;
  top: 10px;
  right: 10px;
  font-size: 10px;
}
.toolbar-icon-button.dialog-button {
  font-size: 16px;
  padding: 10px;
  cursor: pointer;
}
.toolbar-icon-button.dialog-button:hover {
  opacity: 0.5 !important;
}
.toolbar-icon-button img {
  object-fit: contain;
}
.toolbar-icon-text {
  padding: 0 10px;
  cursor: pointer;
  height: 100%;
  line-height: 100%;
}
div[role=menu],
ul[role=menubar] {
  padding: 0px !important;
}
div[role=menu] span[role=menuitem] i#icons,
ul[role=menubar] span[role=menuitem] i#icons {
  margin: 12px !important;
}
div[role=menu] hr,
ul[role=menubar] hr {
  margin: 0px !important;
}
.rs-dropdown-item.rs-dropdown-item-with-icon {
  width: 100% !important;
}
#dropdown-item:hover {
  background-color: rgba(192, 192, 192, 0.3) !important;
}
.rs-popover,
.rs-dropdown-menu {
  border-radius: 2px;
  padding: 0px;
}
.rs-popover-content {
  padding: 0 !important;
}
.yodiwo-toolbar-menu.rs-dropdown-menu .rs-dropdown-item {
  padding: 0px 12px !important;
}
.yodiwo-toolbar-menu.rs-dropdown-menu .rs-dropdown-item-focus {
  background-color: unset;
  color: #575757;
}
.rs-dropdown-menu-mobile .rs-dropdown-item {
  padding: 8px 12px !important;
}
.rs-dropdown-menu-mobile .rs-dropdown-item-focus {
  background-color: var(--rs-menuitem-active-bg);
  color: var(--rs-menuitem-active-text);
}
.toolbar-icon-button-img {
  max-width: unset !important;
}
.tippy-box {
  background-color: #606060;
}
.tippy-arrow {
  color: #606060;
}
#first-level-menu {
  border: none !important;
}
.rs-popover .rs-dropdown-toggle.rs-dropdown-toggle-custom-title,
.rs-popover .rs-dropdown.rs-dropdown-placement-left-start,
.rs-popover .rs-dropdown.rs-dropdown-placement-right-start {
  width: 100%;
}
.rs-popover[class*='placement-bottom'].rs-anim-in {
  transform: none;
}
.rs-popover[class*='placement-bottom'] {
  margin-top: 0px;
}
.rs-popover.rs-anim-in,
.rs-popover.rs-anim-fade,
.rs-anim-collapsing {
  transition: none;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
